"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../../Types");
var components_1 = require("@athena-portal/components");
var Confirmation_1 = require("../../Confirmation");
var react_router_dom_1 = require("react-router-dom");
var MarkRefundAsPaidAction = /** @class */ (function (_super) {
    __extends(MarkRefundAsPaidAction, _super);
    function MarkRefundAsPaidAction(props) {
        var _this = _super.call(this, props) || this;
        _this.processConfirm = function () {
            _this.supportPortalService
                .markRefundInvoiceAsPaid(_this.props.policyNumber, _this.props.invoiceId)
                .subscribe(function (response) {
                if (!(response instanceof Error)) {
                    _this.props.getInvoiceAndPaymentData();
                    _this.supportPortalService.logAgentActivity(_this.props.customerReferenceNumber, {
                        "action": "Mark refund invoice ".concat(_this.props.invoiceId, " as PAID"),
                        "customer": _this.props.policyNumber
                    }).subscribe();
                }
            });
            _this.setState({ showConfirmation: false });
        };
        _this.state = {
            showConfirmation: false,
        };
        return _this;
    }
    MarkRefundAsPaidAction.prototype.render = function () {
        var _this = this;
        return (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { className: "d-block text-primary", to: "#", onClick: function () { return _this.setState({ showConfirmation: true }); }, children: "Refund paid" }), (0, jsx_runtime_1.jsx)(Confirmation_1.default, { show: this.state.showConfirmation, hide: function () { return _this.setState({ showConfirmation: false }); }, confirm: function () { return _this.processConfirm(); }, title: "", message: "Are you sure you want to update status of invoice ".concat(this.props.invoiceId, " to PAID?") })] });
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], MarkRefundAsPaidAction.prototype, "supportPortalService", void 0);
    MarkRefundAsPaidAction = __decorate([
        components_1.authorize,
        (0, components_1.role)("Administrator", "CSR_Lead", "CSR", "Support"),
        __metadata("design:paramtypes", [Object])
    ], MarkRefundAsPaidAction);
    return MarkRefundAsPaidAction;
}(React.Component));
exports.default = MarkRefundAsPaidAction;
//# sourceMappingURL=MarkRefundAsPaidAction.js.map